module.exports = __webpack_public_path__ + "42791689c84b0b59033e6c1782b99519.svg";